import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';


@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  durationInSeconds = 3;

  constructor(private snackBar: MatSnackBar) { }


  // --- errors ---
  openError(errorcode: number): void {
    let msg = 'Something went wrong. (Error ' + errorcode + ')'
    if (errorcode === 0) {
      msg = 'Something went wrong. Please check your connections.'
    }
    this.snackBar.open(msg, null, {
      duration: this.durationInSeconds * 1000,
      panelClass: ['error'],
    });
  }

  openErrorMessage(msg: string): void {
    this.snackBar.open(msg, null, {
      duration: this.durationInSeconds * 1000,
      panelClass: ['error'],
    });
  }

  // --- success ---
  openSuccess(): void {
    this.snackBar.open('success', null, {
      duration: this.durationInSeconds * 1000,
      panelClass: ['success'],
    });
  }

  openSuccessMessage(msg: string): void {
    this.snackBar.open(msg, null, {
      duration: this.durationInSeconds * 1000,
      panelClass: ['success'],
    });
  }

}
